<template>
  <v-form
    ref="bt-form-overdraft"
    v-model="bonus.valid"
  >
    <v-text-field
      label="Overdraft Name"
      v-model="bonus.name"
      dense
    />

    <v-row justify="center">
      <v-select
        label="Status"
        :rules="[v => !!v || 'Status is required']"
        v-model="bonus.status"
        :items="statuses"
        class="col-3 pb-1"
        dense
      />


      <v-text-field
        required
        label="Expire days"
        type="number"
        class="col-3 pb-1 bonus-template_lh-28"
        :rules="[v => !!v || 'Expire is required']"
        v-model="bonus.expire_days"
        dense
      />

      <v-text-field
        required
        label="Amount"
        :rules="[v => !!v && v !== '0' || 'Amount is required']"
        v-model="bonus.amount"
        :suffix="$store.state.manual_transaction.account.currency || ''"
        hide-details
        class="col-3 bonus-template_lh-28"
        dense
      />
    </v-row>

    <v-divider class="mb-3 mt-2" />

    <v-row justify="center" class="px-0 mx-0">
      <v-combobox
        multiple
        auto-select-first
        label="Brands (filter)"
        class="col-6 pl-0"
        hide-details
        @input="clearBrandFilter"
        :search-input.sync="brandsFilterInput"
        v-model="brandsFilter"
        :loading="loadingGames"
        :items="brands"
        dense
      />
      <v-autocomplete
        label="Exclusive for Game"
        item-text="name"
        item-value="game_id"
        hide-details
        class="col-6 pr-0"
        clearable
        v-model="bonus.game_id_exclusive"
        :loading="loadingGames"
        :items="filteredGames"
        dense
      />
    </v-row>
    <v-row justify="center" class="px-0 mx-0">
      <v-autocomplete
        label="Exclusive for Brand"
        hide-details
        clearable
        class="col-6 pl-0"
        v-model="bonus.brand_exclusive"
        :loading="loadingGames"
        :items="providerBrandsAliases"
        dense
      />
      <v-autocomplete
        label="Exclusive for System"
        hide-details
        clearable
        class="col-6 pr-0"
        v-model="bonus.system_exclusive"
        :loading="loadingGames"
        :items="providerSystemsAliases"
        dense
      />
    </v-row>
    <v-divider class="mt-2" />

    <v-row class="px-0 mx-0 flex-wrap">
      <v-col
        cols="12"
        class="pb-0"
      >
        <v-label>Additional Requirements</v-label>
      </v-col>
      <v-col
        cols="6"
        v-for="(label, key) in additionalRequirementOptions"
        :key="key"
      >
        <v-checkbox
          v-model="bonus.additional_rules"
          class="mt-0"
          :label="label"
          :value="key"
          hide-details
          multiple
        />
      </v-col>
    </v-row>
  </v-form>
</template>


<script>

  export default {

    props: [ 'providerSystemsAliases', 'bonus', 'providerBrandsAliases', 'games', 'brands', 'loadingGames' ],

    data: () => ({
      brandsFilterInput: '',
      brandsFilter: [],

      statuses: [
        { text: 'New', value: 'new' },
        { text: 'Active', value: 'active' },
      ],
      additionalRequirementOptions: {
        'kyc.verified': 'KYC Verification',
        'kyc.primary_verification': 'KYC Automatic Verification',
        'account.data.verified.email': 'Email Verification',
        'account.data.verified.phone': 'Phone Number Verification',
      },
    }),

    methods: {
      clearBrandFilter () {
        this.brandsFilterInput = ''
      }
    },

    mounted () {
      if (this.$refs['bt-form-' + this.bonus.type]) this.$refs['bt-form-' + this.bonus.type].validate()
    },

    computed: {
      filteredGames: function () {
        return this.games.filter(g => {
          return this.brandsFilter.length < 1 || (this.brandsFilter.includes(g.brand.alias))
        })
      },
    }

  }
</script>
